import { useMemo, useState } from 'react';

export const useMuiMultSelect = ( { callback, options } ) => {
	const [ selectedOptions, setSelectedOptions ] = useState( [] );
	const [ optionsLength, setOptionsLength ] = useState( options?.length );
	const [ searchText, setSearchText ] = useState( '' );
	const containsText = ( text, searchText ) =>
		text.toLowerCase().indexOf( searchText.toLowerCase() ) > -1;

	const handleRemoveAll = () => {
		setSelectedOptions( [] );
		if ( typeof callback === 'function' ) {
			callback( [] );
		}
	};

	const handleSelectAll = () => {
		const updatedOptions = options?.map( option => option?.id );
		setSelectedOptions( updatedOptions );

		if ( typeof callback === 'function' ) {
			callback( updatedOptions );
		}
	};

	const handleChange = ( event ) => {
		if ( !event.target.value[event.target.value?.length - 1] && !event.target.value?.length ) {
			setSelectedOptions( event.target.value );
			if ( typeof callback === 'function' ) {
				callback( event.target.value );
			}
		}
		if ( event.target.value[event.target.value?.length - 1] ) {
			setSelectedOptions( event.target.value );
			if ( typeof callback === 'function' ) {
				callback( event.target.value );
			}
		}
	};

	const displayedOptions = useMemo(
		() => options.filter( ( option ) => containsText( option?.name, searchText ) ),
    [searchText, options] //eslint-disable-line
	);

	const states = {
		selectedOptions,
		setSelectedOptions,
		optionsLength,
		setOptionsLength,
		searchText,
		setSearchText,
		displayedOptions,
	};
	const handlers = {
		handleChange,
		handleSelectAll,
		handleRemoveAll
	};

	return {
		states,
		handlers,
	};
};